import { useEffect, useRef } from 'react';

export function useClickOutside(onClickOutside) {
  const ref = useRef();

  function handleClickOutside(event) {
    if (!ref.current.contains(event.target)) {
      onClickOutside();
    }
  }

  useEffect(() => {
    document.addEventListener('pointerdown', handleClickOutside);

    return () => {
      document.removeEventListener('pointerdown', handleClickOutside);
    };
  });

  return ref;
}
